module.exports = function(h, row) {
    return row.transaction_type_text;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/audit_trail/columns/transaction_type.jsx